import { FC, ReactNode } from 'react';
import { CircularProgress, Portal, Stack, Typography } from '@mui/material';

import { theme } from '@mopla/mui';

import {
	FullScreenLoaderWrapper,
	LoaderWrapper,
} from './PaymentLoadingOverlay.styles';

interface IProps {
	text: string;
	children?: ReactNode;
	testId?: string;
	/** Render in a Portal, fixed over the whole viewport and above page UI. */
	fullScreen?: boolean;
}

export const PaymentLoadingOverlay: FC<IProps> = ({
	text,
	children,
	testId,
	fullScreen = false,
}) => {
	const Wrapper = fullScreen ? FullScreenLoaderWrapper : LoaderWrapper;
	const overlay = (
		<Wrapper data-testid={testId}>
			<Stack alignItems="center">
				<CircularProgress style={{ color: theme.palette.neutral[0] }} />
				<Typography
					data-testid={testId ? `${testId}-Text` : undefined}
					sx={{
						marginTop: theme.spacing(1),
						color: theme.palette.primary.contrastText,
					}}
					variant="bodyTitle"
				>
					{text}
				</Typography>
				{children}
			</Stack>
		</Wrapper>
	);

	return fullScreen ? <Portal>{overlay}</Portal> : overlay;
};
